module.exports = __webpack_public_path__ + "static/sam-walton-f4228e7356a2ca691f84dbd6e21728cc.jpg";